export default {
  SERVER_ERROR_MESSAGE: 'Beklenmeyen bir hata oluştu, internet bağlantınızı kontrol edin veya lütfen daha sonra tekrar deneyin.',
  GIGS_DELETE_WARNING_DESC: 'Bu iş ilanını silmek istediğine emin misin?',
  CHAT_BLOCKED_BY_OTHER_MESSAGE: 'Karşı taraf sizi engellediği için mesaj gönderemezsiniz.',
  CHAT_BLOCK_MESSAGE: 'Karşı tarafı engellediğiniz için mesaj gönderemezsiniz.',
  TICKET_DELETE_WARNING_DESC: 'Bu Destek Talebini silmek istediğine emin misin?'
}
